import { IAlbum } from 'ngx-lightbox';
import ProductAsset from '../model/product-asset';
import { CollectionHelper } from './collection-helper';
import { GeneralHelper } from './general-helper';
import { StringHelper } from './string-helper';
import Asset from '../model/asset';
import { RequestService } from '../services/request.service';
import { Injectable } from '@angular/core';

@Injectable()
export default class AssetHelper {
  public static readonly FILE_STORAGE_KEY_PREFIX = 'asset-';
  private static readonly DESIGN_FORM_SECTIONS = [
    'internalDesign',
    'tilingDesign',
    'adjustmentInternal',
  ];

  constructor(private requestService: RequestService) {}

  public async uploadFile(file: File, base64: string): Promise<Asset> {
    let asset: Asset = {
      name: file.name,
      type: file.type,
      size: file.size,
      base64: base64,
    };
    return await this.requestService
      .post(asset, 'assets/upload', file.type)
      .toPromise();
  }

  public static getStorageKeyFor(uuid: string): string {
    if (StringHelper.isEmpty(uuid)) {
      throw new Error('uuid must not be empty');
    }
    return AssetHelper.FILE_STORAGE_KEY_PREFIX + uuid;
  }

  public static extractBase64 = (file: File) =>
    new Promise<string>((resolve) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onloadend = () => {
        let rawData = fileReader.result.toString().split('base64,');
        if (rawData.length > 1) {
          resolve(rawData[1]);
        } else {
          resolve(rawData[0]);
        }
      };
    });

  public static filterDesignAssets(productAssets: ProductAsset[]) {
    if (productAssets == null) {
      return;
    }
    CollectionHelper.filterInPlace(
      productAssets,
      (pa) => !pa.archived && this.DESIGN_FORM_SECTIONS.includes(pa.formSection)
    );
  }

  // TODO use this wherever product assets are mapped for use with lightbox
  public static toIAlbum(productAsset: ProductAsset): IAlbum {
    return {
      src: 'api/assets/' + productAsset.asset.uuid,
      caption: productAsset.formSection,
      thumb: 'api/assets/' + productAsset.asset.uuid + '/30',
    };
  }

  public static getIAlbums(assets: AssetLike[]): IAlbum[] {
    const toReturn = [];
    assets.forEach((a) => {
      if (a.uuid != null) {
        const iAlbum = {
          src: `/api/assets/${a.uuid}`,
          caption: a.name,
          thumb: `/api/assets/${a.uuid}`,
        };
        toReturn.push(iAlbum);
      }
    });
    return toReturn;
  }

  public static isProductAsset(o: any): o is ProductAsset {
    return GeneralHelper.hasOwnProperty(o, 'asset');
  }
}

type AssetLike = {
  uuid?: string;
  name?: string;
};

// TODO collect all known form sections here
export enum FORM_SECTIONS {
  SKETCHUP = 'sketchUp',
}
